import styled, { css } from 'styled-components';
import Page from '../../_shared/components/Page';
import ListPageFooter from '../../_shared/components/ListPageFooter';
import isOmpPlatform from '../../_shared/utils/isOmpPlatform';

export const StyledPage = styled(Page)`
  max-width: ${({ theme }) => theme.BP.VDP_DESKTOP_WL};
  padding-top: 77px;
  padding-bottom: 60px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;

  @media only screen and (max-width: ${({ theme }) =>
      theme.BP.VDP_DESKTOP_WL}) {
    max-width: 100%;
    padding-left: 16px;
    padding-right: 16px;
  }

  ${({ isOmp }) =>
    isOmp
      ? `
      padding-left: 16px;
      padding-right: 16px;
  `
      : ''}

  h1 span:nth-child(1) {
    ${() =>
      isOmpPlatform() &&
      css`
        color: ${({ theme }) => theme.COLOUR.DARK_BLUE};
        font-size: 30px;
        font-family: ${({ theme }) => theme.FONT.POPPINS};
        font-weight: 600;
      `}
  }
`;

export const StyledFooter = styled(ListPageFooter)`
  padding-top: 36px;
`;

export const StyledBody = styled.div`
  display: flex;
  flex-flow: row nowrap;
  margin-bottom: 12px;
  flex: 1;
`;
